<template>
<div>
    <div class="mainTop cf">
        <navZcy v-bind:num="4"></navZcy>
        <management></management>
    </div>
    <div>
        <div class="aside">
            <el-tabs :tab-position="leftTab" style="height: 1000px;" @tab-click="tagEvent" v-model="activeName">
                    <el-tab-pane label="风格管理" name="stylePage"></el-tab-pane>
                    <el-tab-pane label="空间管理" name="space"></el-tab-pane>
                    <el-tab-pane label="系列管理" name="series"></el-tab-pane>
                    <el-tab-pane label="系列标签管理" name="seriestag"></el-tab-pane>
                    <el-tab-pane label="APP更新" name="app"></el-tab-pane>
            </el-tabs>
        </div>
    </div>

    <el-col :span="21">
        <div style="margin-left: 10px;margin-top: 10px;">
            <div style="margin-bottom: 10px;">
                <a>工作台</a>
            </div>

            <el-tabs v-model="editableTabsValue" type="card" closable   @tab-remove="removeTab">
                <el-tab-pane
                        v-for="(item) in tabData"
                        :key="item.id"
                        :name="item.name"
                        :label="item.label"
                >
                    <component v-bind:is="item.cmpname"></component>

                </el-tab-pane>
            </el-tabs>
        </div>
    </el-col>
</div>
</template>

<script>
    import management from './management.vue'
    import navZcy from './nav.vue'
    import stylePage from'./style.vue'
    import space from'./room.vue'
    import series from'./series.vue'
    import seriestag from'./seriesGroup'
    import app from'./appComponent'
    export default {
        name: "systemManager",
        components:{
            management,
            navZcy,
            stylePage,
            space,
            series,
            seriestag,
            app,
        },
        data() {
            return {
                leftTab: 'left',
                tabPosition:'top',
                activeName:'',
                editableTabsValue:'',
                tabIndex:0,
                tabData:[],
                componentMap: {
                    stylePage: {
                        name: '风格管理',
                        single: true,
                    },
                    space: {
                        name: '空间管理',
                        single: true
                    },
                    series: {
                        name: '系列管理',
                        single: true
                    },
                    seriestag: {
                        name: '系列标签管理',
                        single: true
                    },
                    app: {
                        name: 'APP更新',
                        single: true
                    },
                }
            };
        },
        methods: {
            tagEvent(tag){
                    var createNew = true
                    var existNodeName = ''
                    if(this.componentMap[tag.name].single)
                    {
                        for(let i=0;i<this.tabData.length;i++){
                            if(this.tabData[i].cmpname == tag.name)
                            {
                                existNodeName=this.tabData[i].name
                                createNew = false
                                break
                            }
                        }
                    }
                    if(createNew) {
                        let newName = tag.name + this.tabIndex
                        let obj = {
                            name: newName,
                            label: this.componentMap[tag.name].single?this.componentMap[tag.name].name:this.componentMap[tag.name].name + this.tabIndex,
                            cmpname: tag.name,
                            id:this.tabIndex
                        }
                        console.log(obj)
                        this.tabData.unshift(obj)
                        this.tabIndex = this.tabIndex + 1
                        this.editableTabsValue=newName
                    }else{
                        this.editableTabsValue=existNodeName
                    }
            },
            removeTab(targetName) {
                for(let i=0;i<this.tabData.length;i++){
                    if(this.tabData[i].name == targetName)
                    {
                        this.tabData.splice(i,1)
                        break
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .aside{
        width: 11%;
        float: left;
    }
</style>
